import { Box, Button, Tab, Tabs, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AuthLayout from "./AuthLayout";
import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useSendOtpMutation } from "../../service/auth";
import { toast } from "react-toastify";
import { OTP_TYPE } from "../../utils/enums";
import Loader from "../../constants/Loader";
import { FormHelperText } from "@mui/material";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const CustomTabPanel: React.FC<TabPanelProps> = ({
  children,
  value,
  index,
  ...other
}) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`simple-tabpanel-${index}`}
    aria-labelledby={`simple-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
  </div>
);

const Signup = () => {
  const navigate = useNavigate();
  const [sendOtp, { isLoading }] = useSendOtpMutation();

  const signupEmailSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
  });

  const signupPhoneSchema = Yup.object().shape({
    phone: Yup.string()
      .min(7, "Phone number must be at least 7 characters")
      .required("Phone number is required"),
  });

  const emailFormik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: signupEmailSchema,
    onSubmit: async (values) => {
      try {
        const payload = {
          email: values.email,
          otpType: OTP_TYPE.SINGNUP,
        };
        const response = await sendOtp(payload).unwrap();
        if (response.statusCode === 200 || response.statusCode === 201) {
          toast.success(response.message || "OTP sent successfully");
          navigate(`/otp?type=signup`, { state: { email: values.email } });
        } else {
          toast.error(response.message || "Failed to send OTP");
        }
      } catch (error: any) {
        toast.error(error?.data?.message || "Something went wrong");
      }
    },
  });

  const phoneFormik = useFormik({
    initialValues: {
      phone: "",
    },
    validationSchema: signupPhoneSchema,
    onSubmit: async (values) => {
      try {
        const payload = {
          phone: values.phone.slice(2),
          countryCode: "+" + values.phone.slice(0, 2),
          otpType: OTP_TYPE.SINGNUP,
        };
        const response = await sendOtp(payload).unwrap();
        if (response.statusCode === 200 || response.statusCode === 201) {
          toast.success(response.message || "OTP sent successfully");
          navigate(`/otp?type=signup`, {
            state: {
              mobileNumber: payload.phone,
              countryCode: payload.countryCode,
            },
          });
        } else {
          toast.error(response.message || "Failed to send OTP");
        }
      } catch (error: any) {
        toast.error(error?.data?.message || "Something went wrong");
      }
    },
  });
  const [valueTabs, setValueTabs] = useState<number>(0);

  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const a11yProps = (index: number) => ({
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  });

  return (
    <AuthLayout>
      <Loader isLoad={isLoading} />
      <div className="authBox">
        <h2>Signup</h2>
        <Box className="custom_tabs1" sx={{ width: "100%", mt: 2 }}>
          <Tabs
            value={valueTabs}
            onChange={handleChangeTabs}
            aria-label="view product tabs"
            className="custom_tabs_links"
          >
            <Tab label="Email" {...a11yProps(0)} />
            <Tab label="Phone Number" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={valueTabs} index={0}>
          <form className="form" onSubmit={emailFormik.handleSubmit}>
            <div className="control_group">
              <label htmlFor="email">Email Address</label>
              <TextField
                id="email"
                name="email"
                type="email"
                placeholder="Enter Email Address"
                className="text_field"
                fullWidth
                value={emailFormik.values.email}
                onChange={emailFormik.handleChange}
                onBlur={emailFormik.handleBlur}
                error={
                  emailFormik.touched.email && Boolean(emailFormik.errors.email)
                }
                helperText={
                  emailFormik.touched.email && emailFormik.errors.email
                }
              />
            </div>

            <div className="form_btn">
              <Button
                type="submit"
                className="btn btn_primary w_100"
                variant="contained"
                disabled={isLoading}
              >
                {isLoading ? "Sending OTP..." : "Signup"}
              </Button>
            </div>
          </form>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <form className="form" onSubmit={phoneFormik.handleSubmit}>
            <div className="control_group ">
              <label htmlFor="phone">Phone Number</label>
              <PhoneInput
                inputProps={{
                  id: "phone",
                  name: "phone",
                  placeholder: "Enter Phone Number",
                }}
                country={"in"}
                autoFormat={false}
                value={phoneFormik.values.phone}
                onChange={(value) => phoneFormik.setFieldValue("phone", value)}
                onBlur={() => phoneFormik.setFieldTouched("phone", true)}
              />
              {phoneFormik.touched.phone && phoneFormik.errors.phone && (
                <FormHelperText error>
                  {phoneFormik.errors.phone}
                </FormHelperText>
              )}
            </div>

            <div className="form_btn">
              <Button
                type="submit"
                className="btn btn_primary w_100"
                variant="contained"
                disabled={isLoading}
              >
                {isLoading ? "Sending OTP..." : "Signup"}
              </Button>
            </div>
          </form>
        </CustomTabPanel>

        <div className="sign_log">
          <p>
            Already have an account ?<button style={{ border: "none", background: "transparent", cursor: "pointer", color: "#D3B88C" }} type="button" onClick={() => navigate("/")}>Login</button>
          </p>
        </div>
      </div>
    </AuthLayout>
  );
};

export default Signup;
